import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DiagnosisExplanation } from '@vi-iot/client';
import { RemoteServiceStore } from '@store';

@Component({
  selector: 'app-diagnosis-explanation-modal',
  templateUrl: './diagnosis-explanation-modal.component.html',
  styleUrls: ['./diagnosis-explanation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosisExplanationModalComponent implements OnInit {
  explanation$: Observable<DiagnosisExplanation | null>;
  isLoading$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { diagnosisName: string; diagnosisTitleKey: string },
    private dialogRef: MatDialogRef<DiagnosisExplanationModalComponent>,
    private remoteServiceStore: RemoteServiceStore
  ) {}

  ngOnInit(): void {
    this.explanation$ = this.remoteServiceStore.getDiagnosisExplanation(this.data.diagnosisName);
    this.isLoading$ = this.remoteServiceStore.isDiagnosisExplanationLoading(
      this.data.diagnosisName
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
